import { render } from "./Logo.vue?vue&type=template&id=d37c93ce"
const script = {}
script.render = render

export default script